// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"22fede9a","213":"e4277a6f","238":"9379e7a0","239":"7b7d44cd","455":"e766ce1f","557":"41e60bac","762":"e95e8aac"}[chunkId] + ".chunk.js";
};